/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';

const styles = {
  container: (theme: Theme) => css`
    position: relative;
    display: flex;
    flex-direction: row;
    height: 100%;
    align-items: center;

    * {
      fill: ${theme.palette.white};
    }

    svg {
      display: block;
    }
  `,
  background: (theme: Theme) => css`
    background-color: ${theme.palette.blue['600']};
    border-radius: 50%;
  `,
};
type Props = {
  size?: number;
  title?: string;
};

// CDS does not support custom fill icons, slack thread: https://coursera.slack.com/archives/CPJET5H4L/p1679674540519889
// Unfortunately the least hacky solution that Remi Marchand could think of in late March 2023 was to:
// copy-paste the icon's svg from CDS, remove the path that defines the border, add an absolutely positioned background
// and then write all the CSS to makes it look good. This is hacky and should ideally be replaced.
const PremiumLockIcon = (props: Props) => {
  const { size = 20, title = 'Premium' } = props;
  return (
    <div css={styles.container} data-testid="premium-lock-icon">
      <div css={styles.background}>
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <title>{title}</title>
          <g clipPath="url(#clip0_6620_4062)">
            <path
              d="M11.19 11.19C11.19 10.8744 11.0646 10.5717 10.8415 10.3485C10.6183 10.1254 10.3156 10 10 10C9.68439 10 9.38171 10.1254 9.15854 10.3485C8.93537 10.5717 8.81 10.8744 8.81 11.19C8.8157 11.393 8.87282 11.5912 8.976 11.7661C9.07919 11.941 9.22508 12.0869 9.4 12.19V13.19H10.6V12.19C10.7749 12.0869 10.9208 11.941 11.024 11.7661C11.1272 11.5912 11.1843 11.393 11.19 11.19Z"
              fill="#1F1F1F"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.0022 3.13778C10.387 3.10644 10.7744 3.15116 11.1421 3.2696C11.5264 3.39333 11.881 3.59486 12.1839 3.86163C12.4869 4.1284 12.7316 4.4547 12.903 4.82019C13.0743 5.18569 13.1685 5.58255 13.1798 5.98605L13.1802 6L13.18 8C13.18 8.27614 12.9561 8.5 12.68 8.5C12.4039 8.5 12.18 8.27614 12.18 8V6.00738C12.1717 5.74338 12.1097 5.48383 11.9975 5.24464C11.8845 5.00347 11.723 4.78815 11.5231 4.61212C11.3232 4.43609 11.0891 4.30311 10.8356 4.22146C10.5821 4.13981 10.3144 4.11125 10.0494 4.13756C10.0151 4.14096 9.98048 4.14081 9.94619 4.1371C9.68124 4.10842 9.41322 4.13521 9.15919 4.21576C8.90516 4.29632 8.67068 4.42888 8.47067 4.605C8.27067 4.78113 8.10952 4.99696 7.99748 5.23876C7.88607 5.47921 7.82565 5.74011 7.82 6.00502V8C7.82 8.27614 7.59614 8.5 7.32 8.5C7.04386 8.5 6.82 8.27614 6.82 8V5.99051C6.82769 5.58528 6.91975 5.18609 7.09015 4.81835C7.26054 4.45061 7.50562 4.12237 7.80979 3.85451C8.11397 3.58666 8.47057 3.38506 8.85691 3.26254C9.22677 3.14526 9.61613 3.10291 10.0022 3.13778Z"
              fill="#1F1F1F"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.5 8C5.5 7.72386 5.72386 7.5 6 7.5H14C14.2761 7.5 14.5 7.72386 14.5 8V15C14.5 15.2761 14.2761 15.5 14 15.5H6C5.72386 15.5 5.5 15.2761 5.5 15V8ZM6.5 8.5V14.5H13.5V8.5H6.5Z"
              fill="#1F1F1F"
            />
          </g>
          <defs>
            <clipPath id="clip0_6620_4062">
              <rect width={size} height={size} fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default PremiumLockIcon;
